import React, { useState } from 'react';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

const CameraComponent = ({ onPhotoCapture }) => {
  const [capturedPhoto, setCapturedPhoto] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const capturePhoto = async () => {
    setIsLoading(true);
    try {
      const photo = await Camera.getPhoto({
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Camera,
        allowEditing: true,
        quality: 90,
        width: 800,
        height: 600,
      });
      
      setCapturedPhoto(photo);
      if (onPhotoCapture) {
        onPhotoCapture(photo);
      }
    } catch (error) {
      console.error('Camera capture error:', error);
      alert('Falha ao capturar foto. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  const selectFromLibrary = async () => {
    setIsLoading(true);
    try {
      const photo = await Camera.getPhoto({
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Photos,
        allowEditing: true,
        quality: 90,
        width: 800,
        height: 600,
      });
      
      setCapturedPhoto(photo);
      if (onPhotoCapture) {
        onPhotoCapture(photo);
      }
    } catch (error) {
      console.error('Photo library error:', error);
      alert('Falha ao selecionar foto. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  const promptForSource = async () => {
    setIsLoading(true);
    try {
      const photo = await Camera.getPhoto({
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Prompt,
        allowEditing: true,
        quality: 90,
        width: 800,
        height: 600,
      });
      
      setCapturedPhoto(photo);
      if (onPhotoCapture) {
        onPhotoCapture(photo);
      }
    } catch (error) {
      console.error('Photo capture error:', error);
      alert('Falha ao obter foto. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="camera-component p-4">
      <h3 className="text-lg font-semibold mb-4">📷 Captura de Fotos</h3>
      
      <div className="camera-buttons space-y-2 mb-4">
        <button
          onClick={capturePhoto}
          disabled={isLoading}
          className="w-full p-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
        >
          {isLoading ? 'Capturando...' : '📸 Tirar Foto'}
        </button>
        
        <button
          onClick={selectFromLibrary}
          disabled={isLoading}
          className="w-full p-3 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50"
        >
          {isLoading ? 'Selecionando...' : '📱 Escolher da Galeria'}
        </button>
        
        <button
          onClick={promptForSource}
          disabled={isLoading}
          className="w-full p-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
        >
          {isLoading ? 'Carregando...' : '🎯 Opções de Foto'}
        </button>
      </div>
      
      {capturedPhoto && (
        <div className="photo-preview">
          <h4 className="text-md font-medium mb-2">Foto Capturada:</h4>
          <img 
            src={capturedPhoto.dataUrl} 
            alt="Captured photo" 
            className="w-full max-w-md mx-auto rounded-lg shadow-lg"
            style={{ maxHeight: '300px', objectFit: 'contain' }}
          />
          <p className="text-sm text-gray-600 mt-2">
            Formato: {capturedPhoto.format} | 
            Tamanho: {capturedPhoto.width}x{capturedPhoto.height}
          </p>
        </div>
      )}
    </div>
  );
};

export default CameraComponent;